module.exports = __webpack_public_path__ + "assets/img/dx4.11d8b5ff.jpg";